export default __webpack_public_path__ + "assets/images/7238bff3efa215daa64d3c036b9a6aa5.png";